export const TOOLBAR_FORM = 'ACTIVITIES_TOOLBAR_FORM';
export const COMMENT_FORM = 'ACTIVITIES_COMMENT_FORM';

export const TABS = {
    FAMLY: 'FAMLY',
    PUBLIC: 'public',
    MINE: 'me',
};
export const FAMLY_ROUTE = 'account.institution.activities.index';
export const STANDALONE_FAMLY_ROUTE = 'account.activities.index';
export const LIBRARY_ROUTE = 'account.institution.activities.library';
export const STANDALONE_LIBRARY_ROUTE = 'account.activities.library';
